/** 카페 포트폴리오 스크린샷 — public/portfolio/cafe/ */

function cafeSrc(filename) {
  return `/portfolio/cafe/${filename}`;
}

function cafeItem(id, title, filename, url) {
  return { id, title, url, src: cafeSrc(filename) };
}

export const CAFE_PORTFOLIO_IMAGES = [
  cafeItem("horizon", "카페 호라이즌", "large-cafe.webp", "cafe-horizon.dsite"),
  cafeItem("terarosa", "테라로사", "cafe-terarosa.webp", "terarosa.com"),
  cafeItem("lune", "루나 디저트카페", "dessert-cafe-2.webp", "lune-dessert.dsite"),
  cafeItem("dalkomm", "달콤커피", "sweet-cafe.webp", "dalkomm.com"),
  cafeItem("paiks", "빽다방", "delivery-cafe.webp", "paiks.co.kr"),
  cafeItem("cancafe", "캔카페", "can-cafe.webp", "cancafe.dsite"),
];

export const DEFAULT_CAFE_IMAGE = CAFE_PORTFOLIO_IMAGES[0];
